import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vModelText as _vModelText, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Teleport as _Teleport, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "list-page-panel is-header-minimal mx-6 pt-6"
};
const _hoisted_2 = {
  class: "list-page-heading"
};
const _hoisted_3 = {
  class: "list-page-heading-actions"
};
const _hoisted_4 = {
  class: "list-page-table-panel list-page-table-panel--fill mx-6"
};
const _hoisted_5 = {
  class: "data-table-shell"
};
const _hoisted_6 = {
  class: "data-table-scroll data-table-scroll--fill"
};
const _hoisted_7 = {
  class: "data-table text-sm min-w-[900px]"
};
const _hoisted_8 = {
  key: 1
};
const _hoisted_9 = {
  class: "data-table-td text-slate-900"
};
const _hoisted_10 = {
  class: "data-table-td text-slate-600"
};
const _hoisted_11 = {
  class: "data-table-td text-slate-600"
};
const _hoisted_12 = {
  class: "data-table-td"
};
const _hoisted_13 = {
  class: "data-table-td text-slate-600"
};
const _hoisted_14 = {
  class: "data-table-td text-slate-600 text-xs"
};
const _hoisted_15 = {
  class: "data-table-td is-center data-table-sticky-right data-table-sticky-action"
};
const _hoisted_16 = {
  class: "flex items-center justify-center gap-1"
};
const _hoisted_17 = ["onClick"];
const _hoisted_18 = ["title", "aria-label", "onClick"];
const _hoisted_19 = {
  key: 0,
  class: "w-4 h-4",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_20 = {
  key: 1,
  class: "w-4 h-4",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_21 = {
  class: "flex-shrink-0 flex items-center justify-between px-6 py-4 border-b border-slate-200"
};
const _hoisted_22 = {
  class: "text-lg font-semibold text-slate-900"
};
const _hoisted_23 = {
  class: "flex-1 overflow-y-auto min-h-0 p-6"
};
const _hoisted_24 = {
  class: "flex-shrink-0 px-6 py-4 border-t border-slate-200 flex justify-end gap-3"
};
const _hoisted_25 = ["disabled"];
import { ref, reactive, computed, onMounted } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import AppPagination from '@/components/AppPagination.vue';
import ListPageShell from '@/components/ListPageShell.vue';
import PageFilterBar from '@/components/PageFilterBar.vue';
import AppModal from '@/components/AppModal.vue';
import { getExternalPersonPage, createExternalPerson, updateExternalPerson, updateExternalPersonStatus } from '@/api/taxPlanning';
export default {
  __name: 'ExternalPersonManagement',
  setup(__props) {
    const personStatusMap = {
      1: {
        label: '启用',
        class: 'status-badge is-success'
      },
      0: {
        label: '停用',
        class: 'status-badge is-neutral'
      },
      default: {
        label: '未知',
        class: 'status-badge is-neutral'
      }
    };
    const filters = reactive({
      keyword: '',
      status: undefined
    });
    const tableData = ref([]);
    const loading = ref(false);
    const total = ref(0);
    const pagination = reactive({
      current: 1,
      size: 10,
      pages: 1
    });
    const formDialogVisible = ref(false);
    const submitting = ref(false);
    const formRef = ref(null);
    const formData = reactive({
      id: null,
      name: '',
      phone: '',
      idCardNo: '',
      remark: ''
    });
    const isEdit = computed(() => !!formData.id);
    const formRules = {
      name: [{
        required: true,
        message: '请输入姓名',
        trigger: 'blur'
      }],
      phone: [{
        validator: (rule, value, callback) => {
          if (!value) {
            callback();
            return;
          }
          if (!/^1\d{10}$/.test(value)) {
            callback(new Error('手机号格式不正确'));
            return;
          }
          callback();
        },
        trigger: 'blur'
      }]
    };
    async function fetchPersonList() {
      loading.value = true;
      try {
        const res = await getExternalPersonPage({
          page: pagination.current,
          size: pagination.size,
          keyword: filters.keyword || undefined,
          status: filters.status
        });
        tableData.value = res.records || [];
        total.value = res.total || 0;
        pagination.pages = Math.max(1, Math.ceil(total.value / pagination.size));
      } catch (error) {
        ElMessage.error('获取外部人员列表失败');
        console.error(error);
      } finally {
        loading.value = false;
      }
    }
    function handleSearch() {
      pagination.current = 1;
      fetchPersonList();
    }
    function handleReset() {
      filters.keyword = '';
      filters.status = undefined;
      handleSearch();
    }
    function handlePageChange(page) {
      if (page < 1 || page > pagination.pages) return;
      pagination.current = page;
      fetchPersonList();
    }
    function handlePageSizeChange(size) {
      pagination.size = size;
      pagination.current = 1;
      fetchPersonList();
    }
    function resetForm() {
      formData.id = null;
      formData.name = '';
      formData.phone = '';
      formData.idCardNo = '';
      formData.remark = '';
    }
    function handleCreate() {
      resetForm();
      formDialogVisible.value = true;
    }
    function handleEdit(row) {
      formData.id = row.id;
      formData.name = row.name || '';
      formData.phone = row.phone || '';
      formData.idCardNo = row.idCardNo || '';
      formData.remark = row.remark || '';
      formDialogVisible.value = true;
    }
    async function handleSubmit() {
      try {
        await formRef.value.validate();
      } catch {
        return;
      }
      submitting.value = true;
      try {
        const payload = {
          name: formData.name,
          phone: formData.phone || undefined,
          idCardNo: formData.idCardNo || undefined,
          remark: formData.remark || undefined
        };
        if (isEdit.value) {
          await updateExternalPerson(formData.id, payload);
          ElMessage.success('更新成功');
        } else {
          await createExternalPerson(payload);
          ElMessage.success('新增成功');
        }
        formDialogVisible.value = false;
        fetchPersonList();
      } catch (error) {
        ElMessage.error(error.message || '保存失败');
        console.error(error);
      } finally {
        submitting.value = false;
      }
    }
    async function handleToggleStatus(row) {
      const nextStatus = row.status === 1 ? 0 : 1;
      const actionText = nextStatus === 1 ? '启用' : '停用';
      const tip = nextStatus === 0 ? '停用后其名下银行卡不可用于新资金任务。' : '';
      try {
        await ElMessageBox.confirm(`确认${actionText}外部人员「${row.name}」吗？${tip}`, `${actionText}确认`, {
          confirmButtonText: `确认${actionText}`,
          cancelButtonText: '取消',
          type: 'warning'
        });
      } catch {
        return;
      }
      try {
        await updateExternalPersonStatus(row.id, nextStatus);
        ElMessage.success(`${actionText}成功`);
        fetchPersonList();
      } catch (error) {
        ElMessage.error(error.message || `${actionText}失败`);
        console.error(error);
      }
    }
    onMounted(() => {
      fetchPersonList();
    });
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_form = _resolveComponent("el-form");
      const _directive_permission = _resolveDirective("permission");
      return _openBlock(), _createBlock(ListPageShell, {
        fill: ""
      }, {
        header: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[10] || (_cache[10] = _createElementVNode("div", {
          class: "list-page-heading-main"
        }, [_createElementVNode("h1", {
          class: "list-page-title"
        }, "外部人员管理"), _createElementVNode("p", {
          class: "list-page-description"
        }, "维护税筹银行卡可绑定的外部人员（非系统用户），停用后其名下银行卡不可用于新资金任务。")], -1)), _createElementVNode("div", _hoisted_3, [_withDirectives((_openBlock(), _createElementBlock("button", {
          class: "btn-primary inline-flex items-center gap-2",
          onClick: handleCreate
        }, [...(_cache[9] || (_cache[9] = [_createElementVNode("svg", {
          class: "w-4 h-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M12 6v6m0 0v6m0-6h6m-6 0H6"
        })], -1), _createTextVNode(" 新增外部人员 ", -1)]))])), [[_directive_permission, 'tax-planning:external-person:add']])])])])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createVNode(PageFilterBar, {
          "shell-class": "filter-bar-shell is-embedded",
          "body-class": "filter-bar-body is-panel",
          "show-refresh": true,
          "refresh-loading": loading.value,
          onRefresh: fetchPersonList
        }, {
          searchActions: _withCtx(() => [_createElementVNode("button", {
            type: "button",
            class: "btn-primary",
            onClick: handleSearch
          }, "搜索"), _createElementVNode("button", {
            type: "button",
            class: "btn-secondary",
            onClick: handleReset
          }, "重置")]),
          default: _withCtx(() => [_withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => filters.keyword = $event),
            type: "text",
            placeholder: "姓名/手机号/证件号",
            class: "form-search-input form-control-sm filter-bar-field"
          }, null, 512), [[_vModelText, filters.keyword]]), _createVNode(_component_el_select, {
            modelValue: filters.status,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => filters.status = $event),
            placeholder: "请选择状态",
            class: "form-select form-control-sm filter-bar-field"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "全部状态",
              value: undefined
            }), _createVNode(_component_el_option, {
              label: "启用",
              value: 1
            }), _createVNode(_component_el_option, {
              label: "停用",
              value: 0
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }, 8, ["refresh-loading"]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("table", _hoisted_7, [_cache[16] || (_cache[16] = _createElementVNode("thead", {
          class: "data-table-head"
        }, [_createElementVNode("tr", null, [_createElementVNode("th", {
          class: "data-table-th text-left"
        }, "姓名"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "手机号"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "证件号"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "状态"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "备注"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "创建时间"), _createElementVNode("th", {
          class: "data-table-th text-center data-table-sticky-right data-table-sticky-head data-table-sticky-action"
        }, "操作")])], -1)), _createElementVNode("tbody", null, [loading.value ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, _renderList(5, n => {
          return _createElementVNode("tr", {
            key: n,
            class: "animate-pulse"
          }, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(7, m => {
            return _createElementVNode("td", {
              key: m,
              class: _normalizeClass(["data-table-td", m === 7 ? 'data-table-sticky-right data-table-sticky-action' : ''])
            }, [...(_cache[11] || (_cache[11] = [_createElementVNode("div", {
              class: "h-4 bg-slate-200 rounded w-24"
            }, null, -1)]))], 2);
          }), 64))]);
        }), 64)) : tableData.value.length === 0 ? (_openBlock(), _createElementBlock("tr", _hoisted_8, [...(_cache[12] || (_cache[12] = [_createElementVNode("td", {
          colspan: "7",
          class: "data-table-empty"
        }, [_createElementVNode("div", {
          class: "flex flex-col items-center"
        }, [_createElementVNode("span", {
          class: "text-slate-500"
        }, "暂无外部人员")])], -1)]))])) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tableData.value, row => {
          return _openBlock(), _createElementBlock("tr", {
            key: row.id,
            class: "data-table-row"
          }, [_createElementVNode("td", _hoisted_9, _toDisplayString(row.name || '-'), 1), _createElementVNode("td", _hoisted_10, _toDisplayString(row.phone || '-'), 1), _createElementVNode("td", _hoisted_11, _toDisplayString(row.idCardNo || '-'), 1), _createElementVNode("td", _hoisted_12, [_createElementVNode("span", {
            class: _normalizeClass(["status-badge", personStatusMap[row.status]?.class || personStatusMap.default.class])
          }, _toDisplayString(personStatusMap[row.status]?.label || '未知'), 3)]), _createElementVNode("td", _hoisted_13, _toDisplayString(row.remark || '-'), 1), _createElementVNode("td", _hoisted_14, _toDisplayString(row.createTime || '-'), 1), _createElementVNode("td", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_withDirectives((_openBlock(), _createElementBlock("button", {
            class: "table-action-button is-primary",
            title: "编辑",
            "aria-label": "编辑",
            onClick: $event => handleEdit(row)
          }, [...(_cache[13] || (_cache[13] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
          })], -1)]))], 8, _hoisted_17)), [[_directive_permission, 'tax-planning:external-person:edit']]), _withDirectives((_openBlock(), _createElementBlock("button", {
            class: _normalizeClass(["table-action-button", row.status === 1 ? 'is-warning' : 'is-success']),
            title: row.status === 1 ? '停用' : '启用',
            "aria-label": row.status === 1 ? '停用' : '启用',
            onClick: $event => handleToggleStatus(row)
          }, [row.status === 1 ? (_openBlock(), _createElementBlock("svg", _hoisted_19, [...(_cache[14] || (_cache[14] = [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636"
          }, null, -1)]))])) : (_openBlock(), _createElementBlock("svg", _hoisted_20, [...(_cache[15] || (_cache[15] = [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
          }, null, -1)]))]))], 10, _hoisted_18)), [[_directive_permission, 'tax-planning:external-person:status']])])])]);
        }), 128))])])])]), _createVNode(AppPagination, {
          class: "pagination-bridge",
          pagination: pagination,
          total: total.value,
          "page-sizes": [10, 20, 50],
          onPageChange: handlePageChange,
          onSizeChange: handlePageSizeChange
        }, null, 8, ["pagination", "total"])]), (_openBlock(), _createBlock(_Teleport, {
          to: "body"
        }, [_createVNode(AppModal, {
          visible: formDialogVisible.value,
          size: "lg",
          onClose: _cache[8] || (_cache[8] = $event => formDialogVisible.value = false)
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_21, [_createElementVNode("h3", _hoisted_22, _toDisplayString(isEdit.value ? '编辑外部人员' : '新增外部人员'), 1), _createElementVNode("button", {
            class: "p-1.5 text-slate-400 hover:text-slate-600",
            onClick: _cache[2] || (_cache[2] = $event => formDialogVisible.value = false)
          }, [...(_cache[17] || (_cache[17] = [_createElementVNode("svg", {
            class: "w-5 h-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])]), _createElementVNode("div", _hoisted_23, [_createVNode(_component_el_form, {
            ref_key: "formRef",
            ref: formRef,
            model: formData,
            rules: formRules,
            "label-width": "100px"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "姓名",
              prop: "name"
            }, {
              default: _withCtx(() => [_withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => formData.name = $event),
                type: "text",
                placeholder: "请输入姓名",
                class: "form-input w-full"
              }, null, 512), [[_vModelText, formData.name]])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "手机号",
              prop: "phone"
            }, {
              default: _withCtx(() => [_withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => formData.phone = $event),
                type: "text",
                placeholder: "请输入手机号（选填）",
                class: "form-input w-full"
              }, null, 512), [[_vModelText, formData.phone]])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "证件号",
              prop: "idCardNo"
            }, {
              default: _withCtx(() => [_withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => formData.idCardNo = $event),
                type: "text",
                placeholder: "请输入证件号（选填）",
                class: "form-input w-full"
              }, null, 512), [[_vModelText, formData.idCardNo]])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "备注"
            }, {
              default: _withCtx(() => [_withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => formData.remark = $event),
                rows: "3",
                placeholder: "可选填写备注信息",
                class: "form-textarea w-full resize-none"
              }, null, 512), [[_vModelText, formData.remark]])]),
              _: 1
            })]),
            _: 1
          }, 8, ["model"])]), _createElementVNode("div", _hoisted_24, [_createElementVNode("button", {
            class: "btn-secondary",
            onClick: _cache[7] || (_cache[7] = $event => formDialogVisible.value = false)
          }, "取消"), _createElementVNode("button", {
            class: "btn-primary",
            disabled: submitting.value,
            onClick: handleSubmit
          }, _toDisplayString(submitting.value ? '保存中...' : '保存'), 9, _hoisted_25)])]),
          _: 1
        }, 8, ["visible"])]))]),
        _: 1
      });
    };
  }
};